<template>
    <!--      机构选择表单部分-->
    <el-dialog title="选择用户" :visible.sync="agentVisible" :before-close="handleClose">
        <!--    搜索部分-->
        <el-form :inline="true" :model="dialogForm" class="demo-form-inline">
          <el-form-item label="名称">
            <el-input size="medium" clearable v-model="dialogForm.user_name" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input size="medium" clearable v-model="dialogForm.mobile_phone" placeholder="请输入"></el-input>
          </el-form-item>
            <el-button size="medium" type="primary" style="font-size: 12px;" @click="handleSearch(dialogForm)">搜索</el-button>
            <el-button size="medium"  style="font-size: 12px;" @click="handelReset()">重置</el-button>
        </el-form>
        <!--    表格部分-->
        <el-table height="250" :data="dialogData" style="width: 100%"
                  :default-sort="{prop: 'date', order: 'descending'}" v-loading="loading" border
                  @row-click="singleElection">
          <el-table-column align="center" width="55">
            <template slot="header">
              <span style="cursor:pointer" @click="cancelClick">取消</span>
            </template>
            <template slot-scope="scope">
              <el-radio class="radio" v-model="templateSelection" :label="scope.row.id">
                {{ " " }}
              </el-radio>
            </template>
          </el-table-column>
          <el-table-column header-align="center" align="center" prop="id" label="ID" sortable>
          </el-table-column>
          <el-table-column header-align="center" align="center" prop="user_name" label="代理商名称">
          </el-table-column>
          <el-table-column header-align="center" align="center" prop="mobile_phone" label="代理商手机号">
          </el-table-column>
        </el-table>
        <!-- 分页部分 -->
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :page-sizes="[20,50,100,200,500,1000]" :page-size="page_size" :total="dialogTotal"
                       layout="total, sizes, prev, pager, next, jumper" style="text-align: right"></el-pagination>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancelDialog">取 消</el-button>
          <el-button type="primary" @click="submitForm">确 定</el-button>
        </div>
      </el-dialog>
</template>
<script>
export default {
    name:'selectAgentUser',
    props: {
        agentVisible: { //是否显示 
            type: Boolean
        },
        ident:{
            type:String|null,
        }
    },
    data() {
        return {
            dialogForm: { //表单搜索数据
                page_size: 20,
                mobile_phone: "", //手机号码
                page: 1,
                user_name: "", //用户名称
                role_code: "", //角色层级编码 
            },
            page_size: 20, //条数
            loading :false, //Loading
            dialogData:[], //数据 
            dialogTotal:0, //总数
            templateSelection: "", //当前选择的行的id
            checkList: [], //当前选择的行的数据
        }
    },
    watch:{
			// 此处监听variable变量，当期有变化时执行
			agentVisible(item1,item2){
                if(item1){
                    if(this.ident == 'yy'){
                        this.dialogForm.role_code = '1003'
                    }else{
                        this.dialogForm.role_code = '';
                    }
                    this.getDialogData(this.dialogForm);
                }else{
                    this.dialogData = [];
                }
			}
	},
    mounted() {
        
    },
    methods: {
        //初始化数据    
        getDialogData(params) { 
            this.loading = true;
            this.$api.post("/api/agent/getSearchUserList?page=" + params.page, params, res => {
                if (res.status == 200) {
                    let dialogData = res.data;
                    this.dialogTotal = dialogData.total; //总数
                    this.dialogData = dialogData.list;
                } else {
                this.$message.error(res.msg);
                }
                //渲染结束后取消加载
                this.loading = false;
            })
        },
        //取消 
        cancelDialog(){
           this.checkList = [];
           this.templateSelection = '';
           this.$emit('setSelectAgent', {'item':this.checkList,'ident':this.ident}); 
           this.$emit('changeAgentVisible',false);      
        },
        //获取每行
        singleElection(row) {
            this.templateSelection = row.id;
            this.checkList = row;
        },
         //取消
        cancelClick() {
            this.checkList = [];
            this.templateSelection = '';
        },
        //表单条数
        handleSizeChange(limit) { 
            this.dialogForm.page_size = limit;
            this.dialogForm.page = 1;
            this.getDialogData(this.dialogForm);
        },
        //当前选中页
        handleCurrentChange(page) { 
            this.dialogForm.page = page;
            this.getDialogData(this.dialogForm);
        },
        // 表单确定
        submitForm() {
            if(this.templateSelection == ''){
                this.$message.error('请选择用户');
                return false;
            }
            this.$emit('setSelectAgent', {'item':this.checkList,'ident':this.ident}); 
            this.$emit('changeAgentVisible',false); 
        },
        //关闭 
        handleClose(){
           //重置信息   
           this.checkList = [];
           this.templateSelection = '';
           this.$emit('changeAgentVisible',false);         
        },
        //搜索 
        handleSearch(dialogForm) {
            dialogForm.page = 1;
            this.getDialogData(dialogForm);
        },
        handelReset(){
            this.dialogForm = { //表单搜索数据
                page_size: 20,
                mobile_phone: "", //手机号码
                page: 1,
                user_name: "", //用户名称
                role_code: this.roleCode, //角色层级编码 
            }
            this.checkList = [];
            this.templateSelection = '';
            this.getDialogData(this.dialogForm);
        }    


    }
}
</script>
<style scoped lang='scss'>

</style>